(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const banner=document.querySelector('.anom-summer-site-banner');
    if(banner) {banner.textContent='Point relais offert sur la Pampa Box';banner.setAttribute('aria-label','Livraison en point relais offerte en France sur la Pampa Box');}
    const $ = selector => root.querySelector(selector);
    const dialog = $('.ab-dialog');
    const form = $('[data-buy-form]');
    const data = new Map([...root.querySelectorAll('[data-product-data]')].map(el => {
      const product = JSON.parse(el.textContent);
      return [String(product.id), product];
    }));
    const locale = root.dataset.locale || 'fr';
    const money = cents => new Intl.NumberFormat(locale, {style:'currency',currency:root.dataset.currency || 'EUR'}).format(cents / 100);
    root.querySelectorAll('[data-price-cents]').forEach(el=>el.textContent=money(Number(el.dataset.priceCents)));
    const base = root.dataset.cartRoot || '/';
    let current, variant, trigger, previousOverflow = '', busy = false;
    const notice = (selector, text) => { const el = $(selector); if(text) el.textContent = text; el.hidden = !text; };
    const format = v => current.category === 'coffee' ? (v.grams >= 1000 ? '1 kg' : '250 g') : current.category === 'box' ? (/petit/i.test(v.title) ? '4 × 250 g' : '4 × 500 g') : v.title.replace('drips bags','Drip Bags').replace('drip bags','Drip Bags');
    function quantity() { return Number(form.elements.quantity.value); }
    function refreshPrice() { if(variant) $('[data-dialog-price]').textContent = money(variant.price * (quantity() || 1)); }
    function selectVariant(id) {
      variant = current.variants.find(v => String(v.id) === String(id));
      const grind = $('[data-grind]');
      const previous = grind.value;
      grind.replaceChildren();
      const options = (variant.grinds || []).map(v => v.trim()).filter(Boolean);
      for(const text of options) {
        const opt = document.createElement('option'); opt.value = text; opt.textContent = text.replace('Cafètiere','Cafetière'); grind.append(opt);
      }
      if(options.includes(previous)) grind.value = previous;
      $('[data-grind-wrap]').hidden = current.category === 'drip' || !options.length;
      grind.required = current.category !== 'drip' && options.length > 0;
      $('[data-add]').disabled = !variant.available;
      refreshPrice();
      notice('[data-error]', ''); notice('[data-success]', '');
    }
    function image(index) {
      $('[data-main-image]').hidden = index === 'taste';
      $('[data-taste-view]').hidden = index !== 'taste';
      if(index !== 'taste') {
        $('[data-main-image]').src = current.images[index].src;
        $('[data-main-image]').alt = current.images[index].alt || current.title;
      }
      root.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.image === String(index))));
    }
    function taste() {
      const notes = current.notes.split(' · ').map(n=>n.trim()).filter(Boolean);
      const group = $('[data-taste-sectors]'); group.replaceChildren();
      const list = $('[data-taste-list]'); list.replaceChildren();
      const colors = ['#ff6335', '#bad1ba', '#d5c5ef', '#d9ab65'];
      notes.forEach((note, i) => {
        const a = (i * 2 * Math.PI / notes.length) - Math.PI / 2;
        const b = ((i + 1) * 2 * Math.PI / notes.length) - Math.PI / 2;
        const shape = document.createElementNS('http://www.w3.org/2000/svg','path');
        shape.setAttribute('d', `M120 120 L${120+100*Math.cos(a)} ${120+100*Math.sin(a)} A100 100 0 ${b-a>Math.PI?1:0} 1 ${120+100*Math.cos(b)} ${120+100*Math.sin(b)} Z`);
        shape.setAttribute('fill',colors[i%colors.length]);shape.setAttribute('stroke','#f9f4e5');shape.setAttribute('stroke-width','4');group.append(shape);
        const li = document.createElement('li'); li.textContent = note; li.style.setProperty('--note-color', colors[i%colors.length]);list.append(li);
      });
    }
    function open(id, button) {
      current = data.get(String(id)); if(!current) return;
      trigger = button;
      dialog.style.setProperty('--ab-accent',current.color);
      $('[data-dialog-origin]').textContent = current.origin;
      $('[data-dialog-title]').textContent = current.title;
      $('[data-dialog-notes]').textContent = current.notes;
      $('[data-dialog-description]').textContent = current.description;
      $('[data-dialog-delivery]').textContent = current.delivery;
      $('[data-full-product]').href = current.url;
      $('[data-full-product]').firstChild.textContent = current.category === 'coffee' ? "L'histoire de ce café " : 'Découvrir tous les détails ';
      form.elements.quantity.value = '1';
      const sizes = $('[data-sizes]'); sizes.replaceChildren();
      current.variants.forEach(v => {
        const label = document.createElement('label'); label.className = 'ab-size';
        const radio = document.createElement('input');radio.type='radio';radio.name='variant';radio.value=v.id;radio.disabled=!v.available;radio.required=true;
        radio.checked = v.id === current.defaultVariant;
        radio.addEventListener('change',()=>selectVariant(v.id));
        const text = document.createElement('span');text.textContent=format(v);label.append(radio,text);sizes.append(label);
      });
      const thumbs = $('[data-thumbnails]'); thumbs.replaceChildren();
      current.images.forEach((photo,i) => {
        const b = document.createElement('button');b.type='button';b.dataset.image=i;b.setAttribute('aria-label',`Photo ${i+1} de ${current.title}`);
        const img = document.createElement('img');img.src=photo.src;img.alt='';img.loading='lazy';b.append(img);b.addEventListener('click',()=>image(i));thumbs.append(b);
      });
      if(current.category === 'coffee') {
        const b = document.createElement('button');b.type='button';b.dataset.image='taste';b.className='ab-taste-thumb';b.textContent='En tasse';b.addEventListener('click',()=>image('taste'));thumbs.append(b);taste();
      }
      image(0);selectVariant(current.defaultVariant);
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden';
      dialog.showModal(); dialog.scrollTop = 0;
    }
    function close() { if(!busy) dialog.close(); }
    $('[data-close]').addEventListener('click',close);
    dialog.addEventListener('click',event=> { if(event.target===dialog) { const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) close(); } });
    dialog.addEventListener('cancel',event=> { if(busy) event.preventDefault(); });
    dialog.addEventListener('close',()=> {document.documentElement.style.overflow=previousOverflow;trigger?.focus({preventScroll:true});});
    root.querySelectorAll('[data-open]').forEach(button=>button.addEventListener('click',()=>open(button.dataset.open,button)));
    root.querySelectorAll('[data-quantity]').forEach(button=>button.addEventListener('click',()=> {
      form.elements.quantity.value=String(Math.max(1,Math.min(20,(quantity()||1)+Number(button.dataset.quantity))));refreshPrice();
    }));
    form.elements.quantity.addEventListener('input',refreshPrice);
    function count() { const n=[...root.querySelectorAll('.ab-product')].filter(p=>!p.hidden).length;$('[data-count]').textContent=`${n} produit${n>1?'s':''}`; }
    root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=> {
      root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      root.querySelectorAll('.ab-product').forEach(card=>card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter);count();
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if(busy || !form.reportValidity() || !variant?.available) return;
      busy=true;const add=$('[data-add]');add.disabled=true;add.setAttribute('aria-busy','true');
      notice('[data-error]','');notice('[data-success]','');
      const cart=document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections=cart?.getSectionsToRender?.().map(s=>s.id) || ['cart-icon-bubble'];
      const item={id:variant.id,quantity:quantity()};
      if(current.category!=='drip' && $('[data-grind]').value) item.properties={Mouture:$('[data-grind]').value};
      let added=false;
      try {
        const response=await fetch(`${base}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item],sections,sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok || result.status) throw Error(result.description || result.message || "Ce produit n'a pas pu être ajouté. Réessayez.");
        added=true;
        if(cart?.renderContents && result.sections) {
          dialog.close();cart.classList.remove('is-empty');cart.renderContents(result);
        } else {
          const status=$('[data-success]');status.hidden=false;
          const bubble=result.sections?.['cart-icon-bubble'];
          if(bubble) {const html=new DOMParser().parseFromString(bubble,'text/html');const dest=document.getElementById('cart-icon-bubble');const src=html.querySelector('.shopify-section');if(dest&&src)dest.innerHTML=src.innerHTML;}
        }
      } catch(error) {
        if(added) $('[data-success]').hidden=false;
        else notice('[data-error]',error instanceof TypeError ? 'Connexion interrompue. Vérifiez votre panier avant de réessayer.' : error.message || "Ce produit n'a pas pu être ajouté. Réessayez.");
      } finally {busy=false;add.disabled=!variant.available;add.removeAttribute('aria-busy');}
    });
    count();
  }
  document.querySelectorAll('[data-anom-boutique]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-anom-boutique]').forEach(init));
})();
